import React from 'react';
import payment_1 from "../../img/payment/payment-1.png"
import payment_2 from "../../img/payment/payment-2.png"
import payment_3 from "../../img/payment/payment-3.png"
import payment_4 from "../../img/payment/payment-4.png"
import payment_5 from "../../img/payment/payment-5.png"
import logo from "../../img/logo.png"


const Footer = () => {

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="footer__about">
              <div className="footer__logo">
                <a ><img src={logo} alt="" /></a>
              </div>
              <p>Votre satisfaction est notre priorité. Explorez, achetez en toute confiance, et profitez d'une expérience de shopping en ligne exceptionnelle.<br/> Bon shopping !</p>
              <div className="footer__payment">
                <a ><img src= {payment_1} alt="" /></a>
                <a ><img src= {payment_2} alt="" /></a>
                <a ><img src= {payment_3} alt="" /></a>
                <a ><img src= {payment_4} alt="" /></a>
                <a ><img src= {payment_5} alt="" /></a>
              </div>
            </div>
          </div>

        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="footer__copyright__text">
              <p>Copyright &copy; {new Date().getFullYear()} All rights reserved | This website is made by <a href="tel:+21658023439"><b>Rafik SOUIFI</b></a></p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
<a href="tel:58023439" className="contact-number"></a>
export default Footer;
